<!--
 * @Description: 文档-关联关系
-->
<template>
  <div class="relation-content">
    <el-row :gutter="20" class="w-full">
      <el-col :span="10">
        <!-- <div class="header-content mb-20px" v-if="fileList && fileList.length > 0">
          <el-button @click="uploadAll" size="mini">
            {{ `${$t('updateAll')}` }}
          </el-button>
          <el-button @click="uploadChoose" size="mini">{{ `${$t('updateSelected')}` }}</el-button>
        </div> -->
        <div class="mb-10px">
          <!-- <el-button type="danger" @click="deleteRightList" size="small">删除</el-button> -->
          <el-button type="primary" @click="setDefaultFile" size="mini">设为主文件</el-button>
          <!-- <el-button type="primary" @click="setDefaultFile" size="small">上移</el-button>
          <el-button type="primary" @click="setDefaultFile" size="small">下移</el-button> -->
        </div>
        <div>
          <el-table
            :data="fileList"
            style="width: 100%"
            ref="fileTable"
            :highlight-current-row="true"
            @row-click="handleClickList"
            @selection-change="selectFile"
            v-if="refreshFileTable"
            border
            height="200px"
          >
            <el-table-column type="selection" width="50"></el-table-column>
            <el-table-column :label="`${$t('fileName')}`" show-overflow-tooltip>
              <template slot-scope="scope" class="w-full">
                <div class="flex w-full">
                  <div class="flex-1 truncate">{{ scope.row.fileNameOrigin }}</div>
                  <el-tooltip
                    :content="`${$t('defaultFile')}`"
                    :open-delay="1000"
                    v-if="scope.row.isDefault"
                    class="ml-10px"
                  >
                    <i class="iconfont icon-bg-collection"></i>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="`${$t('operate')}`" width="200">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  style="color: #333; border: 1px solid #ccc"
                  size="mini"
                  v-if="scope.$index !== 0"
                  @click="changeFileLevel('up', scope.$index)"
                  >上移</el-button
                >
                <el-button
                  type="text"
                  style="color: #333; border: 1px solid #ccc"
                  size="mini"
                  v-if="scope.$index !== fileList.length - 1"
                  @click="changeFileLevel('down', scope.$index)"
                  >下移</el-button
                >

                <el-popover placement="top" v-model="scope.row.isDelete" class="ml-10px">
                  <p class="mb-10px">是否确定要删除？</p>
                  <div class="tr">
                    <el-button size="mini" type="text" @click="scope.row.isDelete = false">{{
                      `${$t('Cancel')}`
                    }}</el-button>
                    <el-button type="primary" size="mini" @click.stop="confirmDelete">{{
                      `${$t('Sure')}`
                    }}</el-button>
                  </div>
                  <el-button
                    type="text"
                    style="color: #333; border: 1px solid #ccc"
                    @click.stop="deleteRightList(scope.$index)"
                    slot="reference"
                    :title="`${$t('delete')}`"
                    size="mini"
                    >删除</el-button
                  >
                </el-popover>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- <el-upload
          drag
          action="https://xx.yy.zz"
          :show-file-list="false"
          :before-upload="getFileContent"
          :http-request="httpRequest"
          :multiple="false"
          class="mt-10px uploadDoc w-full"
        >
          <i style="font-size: 67px" class="el-icon-upload"></i>
          <div class="el-upload__text">
            {{ $t('onlyOneFileCanBeUploadedAtATime') }},{{ $t('or') }}
            <em>{{ $t('clickUpload') }}</em>
          </div>
        </el-upload> -->
        <chunkUploadFiles
          class="w-full"
          :initFiles="initFiles"
          :multipleable="multipleable"
          :uploadParams="uploadParams"
          @uploadSuccess="uploadSuccess"
        ></chunkUploadFiles>
      </el-col>
      <el-col :span="14" class="relative">
        <div class="absolute -top-120px w-full h-110px overflow-y-auto" v-if="parseList.length">
          <div v-for="item in parseList" :key="item.fileId" class="mb-5px">
            <div class="flex w-[calc(100%-30px)]">
              <span class="whitespace-nowrap">{{ item.name }}</span>
              <span v-if="item.msg" class="ml-10px truncate">{{ item.msg }}</span>
              <span v-if="item.timer" class="ml-10px whitespace-nowrap">{{
                item.seconds | formatSeconds
              }}</span>
            </div>
            <el-progress
              :percentage="item.percent"
              :stroke-width="8"
              :text-inside="false"
              :class="{
                'progress-loading': item.timer,
              }"
            />
          </div>
        </div>
        <div class="mb-10px">
          <el-input
            size="mini"
            @keyup.enter.native="handleFilterTag"
            clearable
            placeholder="输入对象名称"
            v-model="tagKeywords"
            style="width: 48%"
            class="mr-10px"
          ></el-input>
          <el-button type="primary" size="mini" @click="handleSearchTag">{{
            `${$t('search')}`
          }}</el-button>
          <el-button type="primary" size="mini" @click="addTag" class="!ml-10px"
            >添加关联</el-button
          >
          <el-button type="primary" size="mini" @click="batchAddTags" class="!ml-10px"
            >批量关联</el-button
          >
          <el-button
            type="primary"
            size="mini"
            :loading="saveTagLoading"
            @click="resolveTags"
            class="!ml-10px"
            >重解关联</el-button
          >
        </div>
        <el-table
          height="410px"
          v-loading="tableLoading"
          :data="fileData"
          class="w-full"
          highlight-current-row
          border
        >
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column prop="tagName" :label="`${$t('objectName')}`" show-overflow-tooltip>
            <template slot-scope="scope">
              <div>{{ scope.row.tagCode }}【{{ scope.row.tagName }}】</div>
            </template>
          </el-table-column>
          <el-table-column :label="`${$t('operate')}`" width="100">
            <template slot-scope="scope">
              <el-popover placement="top" v-model="scope.row.isDelete">
                <p class="mb-10px">{{ `${$t('WhetherToDisassociate')}?` }}</p>
                <div class="tr">
                  <el-button size="mini" type="text" @click="scope.row.isDelete = false">{{
                    `${$t('Cancel')}`
                  }}</el-button>
                  <el-button type="primary" size="mini" @click="confirmRightDelete">{{
                    `${$t('Sure')}`
                  }}</el-button>
                </div>
                <el-button
                  style="color: #333; border: 1px solid #ccc"
                  type="text"
                  @click="deleteLeftList(scope.$index)"
                  slot="reference"
                  :title="`${$t('Disassociate')}`"
                  size="mini"
                  >解除关联</el-button
                >
              </el-popover>
            </template>
          </el-table-column>
        </el-table>
        <div class="float-right mt-10px">
          <el-pagination
            small
            background
            layout="total, prev, pager, next"
            @current-change="tagPageChange"
            :current-page="page.pageNo"
            :page-size="page.pageSize"
            :total="page.count"
          ></el-pagination>
        </div>
      </el-col>
    </el-row>

    <!-- 批量关联导入文档 -->
    <!-- <wiz-upload-file
      v-dialogDrag
      @refreshList="handleSearchTag"
      :uploadFileProps="uploadFileProps"
      @exportTemplate="exportTemplate"
      @importTemplate="importTemplate"
    ></wiz-upload-file> -->
    <UploadXMLFile
      ref="uploadXMLFile"
      v-dialogDrag
      @refreshList="handleSearchTag"
      :uploadFileProps="uploadFileProps"
      @exportTemplate="exportTemplate"
      @importTemplate="importTemplate"
    ></UploadXMLFile>

    <!-- 添加关联关系 -->
    <el-dialog
      width="840px"
      :append-to-body="true"
      :title="$t('addAssociation')"
      :visible.sync="objectTableVisible"
      :close-on-click-modal="false"
      @close="closeObjectTable"
      v-dialogDrag
    >
      <el-row :gutter="10">
        <el-col :span="18">
          <el-input v-model="objectNameKeyword" clearable />
        </el-col>
        <el-col :span="6" class="pull-right">
          <el-button type="primary" class="iconfont icon-search" @click="searchObjectTable">{{
            `${$t('search')}`
          }}</el-button>
        </el-col>
      </el-row>
      <el-table
        height="420px"
        class="mt-10px"
        :data="objectTableData"
        @selection-change="tableSelectionChange"
        ref="multipleTable"
        v-loading="objectTableLoading"
        border
      >
        <el-table-column type="selection"></el-table-column>
        <el-table-column :label="$t('代码')" prop="code"></el-table-column>
        <el-table-column :label="$t('名称')" prop="name"></el-table-column>
        <el-table-column label="别名">
          <template slot-scope="scope">
            <el-input v-model="scope.row.value" clearable></el-input>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @size-change="searchObjectTable"
        @current-change="objectTableCurrentChange"
        :current-page.sync="objectTablePage.pageNo"
        :page-sizes="$pageSizeAll"
        :page-size.sync="objectTablePage.pageSize"
        layout="->, total, sizes, prev, pager, next"
        :total="objectTablePage.total"
        class="mt-10px"
      ></el-pagination>
      <div slot="footer">
        <el-button size="small" @click="closeObjectTable">{{ `${$t('Cancel')}` }}</el-button>
        <el-button
          type="primary"
          size="small"
          :loading="saveObjectTableLoading"
          @click="saveObectTable"
          >{{ `${$t('save')}` }}</el-button
        >
      </div>
    </el-dialog>
    <model-view
      v-if="showModelView"
      ref="modelView"
      class="bg-white absolute -left-9999px -top-9999px"
      playerEngineId="splitEngineId"
      :cloudRender="cloudRender"
      :modelProps="modelProps"
      :showDocComponent="false"
      :modelParams="modelParams"
      :modelName="modelName"
      :basicTabBar="[]"
      :businessTabBar="[]"
      @sendPlayer="($event) => (mainPlayer = $event)"
      @LoadedAllModel="loadedAllModel"
      @loadError="loadError"
    ></model-view>
  </div>
</template>

<script>
import SparkMD5 from 'spark-md5'
import DocumentService from '@/services/DocumentService'
import documentManagementService from '@/services/documentManagement'
import ApiMixinDocumentList from '@/assets/js/api/documentList'
import { deleteFileList, relieveTag, getTagKeywords } from '@/api/article'
import { instance as cloudRender } from 'wiz-cloud-render-vulkan'
import { getUrl } from '@/api/config'
import fnMixin from '@/assets/js/fnMixins'
import chunkUploadFiles from './chunkUploadFiles'
import UploadXMLFile from './uploadXMLFile'
import ModelServer from '../views/model-file-management/services/modelServer'

const ModelView = () => {
  return import('@/modules/resource/components/model/ModelViewVk')
}
export default {
  props: {
    associatedDocumentsProps: {
      type: Object,
      default: () => {},
    },
  },
  mixins: [ApiMixinDocumentList, fnMixin],
  components: {
    chunkUploadFiles,
    UploadXMLFile,
    ModelView,
  },
  data() {
    return {
      tableLoading: false,
      fileList: [],
      fileId: '', // 行点击的文件id
      fileSelectionsIds: [], // 勾选的文件id
      refreshFileTable: true,
      fileData: [],
      page: {
        // 关联关系的
        pageNo: 1,
        pageSize: 15,
        count: 0,
      },
      tagKeywords: '',
      objectTableVisible: false,
      tagValue: '',
      searchData: [], // 远程搜索的数据
      tagId: '', // 位号id
      aliasValue: '', // 添加关联关系-别名
      objectNameKeyword: '',
      objectTableLoading: false,
      saveObjectTableLoading: false,
      objectTableData: [],
      objectTablePage: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      objectTableSelections: [],
      uploadFileProps: {
        visible: false, // 是否开启弹窗
        active: 1, // 目前状态页面1为下载模板 2为上传模板 3为完成
        btnLoading: false, // 按钮加载状态
        isTestAndVerify: true, // 是否开启校验格式
        type: ['xls', 'xlsx', 'xml'], // 检验文件格式，为数组可传多种同类型格式
        successCount: 0, // 上传成功条数
        failureCount: 0, // 上传失败条数
        resultFile: '', // 导入结果id，下载导入结果时需要使用
      },
      sliceSize: 5 * 1024 * 1024,
      batchKey: '',
      mergeCount: 0,
      md5List: [],
      fileSelections: [], // 选中的文件列表数据
      saveTagLoading: false,
      initFiles: [],
      multipleable: true,
      uploadParams: {
        standardId: '',
        documentId: '',
      },
      parseList: [],
      modelType: ['pr', 'pprj', 'rvm', 'fbx', 'vue'],
      parseQueue: [],
      showModelView: false,
      modelParams: [],
      modelProps: {},
      modelName: '',
    }
  },
  filters: {
    formatSeconds(seconds) {
      if (_.isNil(seconds) || _.isNaN(seconds)) {
        return '00:00'
      }
      seconds = Number(seconds)
      if (seconds < 0) seconds = 0
      const m = Math.floor(seconds / 60)
      const s = Math.floor(seconds % 60)
      return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`
    },
  },
  computed: {
    config() {
      return Wiz.globalSettings.dynamicModules.modules['legacy-resource']?.config || {}
    },
    cloudRender() {
      return cloudRender
    },
  },
  watch: {
    associatedDocumentsProps: {
      deep: true,
      immediate: true,
      handler(val) {
        // console.log(val, 'val')
        if (val) {
          this.uploadParams.standardId = val.standardId
          this.uploadParams.documentId = val.rowData.id
        }
      },
    },
    'associatedDocumentsProps.rowData': {
      deep: true,
      immediate: true,
      handler(val) {
        if (val && val.id) {
          this.getFileList1()
        }
      },
    },
  },
  methods: {
    // 关联关系右侧点击取消关联的确定操作
    async confirmIntelligenceTag() {
      const res = await documentManagementService.confirmIntelligenceTag({
        fileId: this.fileId || '',
        tagId: this.tagId,
        identifier: encodeURIComponent(this.aliasValue),
      })
      if (res && res.code === 0) {
        this.tagDataByFile()
        this.$message({
          title: this.$t('success'),
          message: '关联成功',
          type: 'success',
          duration: 500,
          onClose: () => {
            this.aliasValue = ''
            this.tagValue = ''
            this.isShowAdd = false
          },
        })
      } else {
        this.$message.error(res.msg)
      }
    },
    handleSelect(item) {
      this.tagId = item.id
    },
    async getTagKeywords1(standardId, fileId, queryString) {
      // const query = getUrl(this.currentProject.id, id, value)
      const query = {
        standardId,
        fileId,
        queryString,
      }
      const searchData = await getTagKeywords(query)
      if (searchData.data && searchData.data.code === 0) {
        this.searchData = searchData.data.data
      }
      return this.searchData
    },
    createStateFilter(queryString) {
      return (restaurants) => {
        return (
          restaurants.name.toLowerCase().indexOf(queryString.toLowerCase()) !== -1 ||
          restaurants.code.toLowerCase().indexOf(queryString.toLowerCase()) !== -1
        )
      }
    },
    // 从服务端搜索数据
    async querySearchAsync(queryString, cb) {
      const searchTag = await this.getTagKeywords1(
        this.associatedDocumentsProps.standardId,
        this.fileId,
        queryString
      )
      const results = queryString
        ? searchTag.filter(this.createStateFilter(queryString))
        : searchTag
      _.forEach(results, (i) => {
        i.value = `${i.code}-${i.name}`
        // if (i.nameSpace) {
        //   i.value = `${i.code}[${i.name}]`
        // } else {
        //   i.value = `${i.name}`
        // }
      })
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        cb(results)
      }, 3000 * Math.random())
    },
    // 点击取消关闭添加按钮
    closeAddBtn() {
      this.aliasValue = ''
      this.tagValue = ''
      this.isShowAdd = false
      // this.uploadFileBol=false
    },
    // 设置默认文件
    async setDefaultFile() {
      if (this.fileSelectionsIds.length < 1) {
        this.$message.warning(`${this.$t('PleaseCheckTheFileAndThenSetTheDefaultFile')}`)
      } else if (this.fileSelectionsIds.length > 1) {
        this.$message.warning(`${this.$t('OnlyOneDefaultFileCanBeSet')}`)
      } else {
        const res = await this.apiDocumentList({
          method: 'setDefaultFile',
          params: {
            fileId: this.fileSelectionsIds[0],
            id: this.associatedDocumentsProps.rowData.id,
            standardId: this.associatedDocumentsProps.standardId,
          },
        })
        if (res && res.code === 0) {
          this.$message.success(`${this.$t('SetDefaultFileSuccessfully')}`)
          this.getFileList1()
        }
      }
    },
    // 双击关联关系表格触发的事件
    handleClickList(row) {
      this.fileId = row.id
      this.tagDataByFile()
    },
    // 获取关联关系右侧的表单数据
    async tagInfoByFile() {
      if (this.fileId) {
        const res = await this.apiDocumentList({
          method: 'tagInfoByFile',
          params: {
            DocumentFileId: this.fileId,
            SkipCount: (this.page.pageNo - 1) * this.page.pageSize,
            MaxResultCount: this.page.pageSize,
            Keywords: this.tagKeywords || ' ',
            StandardId: this.associatedDocumentsProps.standardId,
          },
          extra: { errorMsg: false },
        })
        if (res && res.code === 0) {
          return res
        }
        return {}
      }
      return {}
    },
    // 获取关联关系右侧的文件内容
    async tagDataByFile() {
      this.tableLoading = true
      const data = await this.tagInfoByFile()
      _(data.data).forEach((item) => {
        item.isDelete = false
      })
      this.tableLoading = false
      this.fileData = data.data
      this.page.count = data.totalCount
    },
    /* 获取关联关系左侧tab */
    async getFileList1() {
      const res = await documentManagementService.getFileList({
        id: this.associatedDocumentsProps.rowData.id,
        standardId: this.associatedDocumentsProps.standardId,
      })
      if (res.length > 0) {
        res.forEach((item) => {
          item.isDelete = false // isRemove
          item.isDelete1 = false // isRemove
        })
        this.fileList = res
        // 设置默认选中第一行
        this.$refs.fileTable.setCurrentRow(this.fileList[0])
        this.handleClickList(this.fileList[0])
      } else {
        this.fileList = []
      }
    },
    // 获取当前选中文件的id
    selectFile(val) {
      this.fileSelections = val
      this.fileSelectionsIds = val.map((item) => {
        return item.fileIdOrigin
      })
    },
    // 上移或下移
    async changeFileLevel(type, index) {
      const currentIndex = type === 'up' ? index - 1 : index + 1
      const temp = this.fileList[index]
      this.fileList[index] = this.fileList[currentIndex]
      this.fileList[currentIndex] = temp
      this.refreshFileTable = false
      this.$nextTick(async () => {
        this.refreshFileTable = true
        const res = await documentManagementService.updateFileOrder({
          documentFileIds: _.map(this.fileList, (item) => {
            return item.id
          }),
          documentId: this.associatedDocumentsProps.rowData.id,
        })
        if (res && res.code === 0) {
          this.getFileList1() // 获取文件列表
        }
      })
    },
    // 关联关系左侧tab中点击确认删除
    confirmDelete() {
      const id = this.fileList[this.index].id
      const fileName = this.fileList[this.index].fileName
      const $lis = $('.filelist').find('li')
      for (let i = 0; i < $lis.length; i += 1) {
        if (
          $lis
            .eq(i)
            .find('.title')
            .html() === fileName
        ) {
          // 通过判断文件名称相同删除文件区域中相对应的文件
          $lis
            .eq(i)
            .off()
            .find('.file-panel')
            .off()
            .end()
            .remove()
        }
      }
      this.deleteFileList1(id, this.index)
    },
    // 删除关联关系tab列表的请求
    deleteFileList1(id) {
      // const data = [id]
      const data = { documentFileId: id }
      this.fileId = id
      deleteFileList(data)
        .then((res) => {
          if (res.data.code === 0) {
            // this.getDocumentTags1()
            // 删除成功后将fileId置空
            this.fileSelectionsIds = []
            this.$message({
              title: this.$t('success'),
              message: '删除成功',
              type: 'success',
              duration: 2000,
            })
            this.isShowLeft = -1
            this.fileData = []
            this.getFileList1()
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 关联关系左侧的tab中点击删除图标
    deleteRightList(index) {
      if (this.isShowLeft === index) {
        this.isShowLeft = -1
      } else {
        this.isShowLeft = index
      }
      this.index = index
    },
    // 点击关联关系右边tab的删除图标
    deleteLeftList(index) {
      if (this.isShowRight === index) {
        this.isShowRight = -1
      } else {
        this.isShowRight = index
      }
      this.index = index
    },
    getFileContent(file) {
      this.file = file
    },
    // 自定义上传文件
    async httpRequest(params) {
      const form = new FormData()
      form.append('file', params.file)
      form.append('documentId', this.associatedDocumentsProps.rowData.id)
      form.append('standardId', this.associatedDocumentsProps.standardId)
      const res = await DocumentService.uploadReleFile(form)
      if (res && res.code === 0) {
        this.$message.success(res.msg)
        this.getFileList1() // 获取文件列表
      } else {
        this.$message.warning(res.msg)
      }
    },
    uploadSuccess(val) {
      if (val) {
        this.getFileList1()
      }
    },
    // 按回车键搜索位号
    handleFilterTag() {
      if (!this.fileId) {
        this.$message({
          message: this.$t('PleaseClickTheFileListOnTheLeft'),
          type: 'warning',
          duration: 2000,
        })
        return
      }
      // this.getDocumentTags1()
      this.tagDataByFile()
    },
    // 点击位号搜索
    handleSearchTag() {
      if (!this.fileId) {
        this.$message({
          message: this.$t('PleaseClickTheFileListOnTheLeft'),
          type: 'warning',
          duration: 2000,
        })
        return
      }
      this.page.pageNo = 1
      this.tagDataByFile()
    },
    // 关联关系右边点击新增添加位号
    addTag() {
      if (!this.fileId) {
        this.$message.warning(this.$t('PleaseSelectADocumentToLink'))
        return
      }
      this.objectTableVisible = true
      this.searchObjectTable()
    },
    // 点击关联关系右边确认删除
    confirmRightDelete() {
      const id = this.fileData[this.index].id
      this.relieveTag1(id)
    },
    // 解除位号关联
    relieveTag1(tagId) {
      const query = getUrl(tagId)
      relieveTag(query).then((res) => {
        if (res.data && res.data.code === 0) {
          this.$message({
            title: this.$t('success'),
            message: this.$t('DisassociationSucceeded'),
            type: 'success',
            duration: 2000,
          })
          this.isShowRight = -1
          // this.getDocumentTags1()
          this.tagDataByFile()
        }
      })
    },
    tagPageChange(val) {
      this.page.pageNo = val
      this.tagDataByFile()
    },
    // 添加关联关系表格多选
    tableSelectionChange(val) {
      this.objectTableSelections = val
    },
    // 表格搜索
    searchObjectTable() {
      this.objectTablePage.pageNo = 1
      this.getObjectTableData()
    },
    // 获取表格数据
    async getObjectTableData() {
      this.objectTableLoading = true
      const res = await DocumentService.getFileReleTagList({
        standardId: this.associatedDocumentsProps.standardId,
        fileId: this.fileId,
        Keywords: this.objectNameKeyword,
        skipCount: (this.objectTablePage.pageNo - 1) * this.objectTablePage.pageSize,
        maxResultCount: this.objectTablePage.pageSize,
      })
      this.objectTableLoading = false
      if (res && res.code === 0 && res.data && res.data.length > 0) {
        this.objectTableData = res.data
        this.objectTablePage.total = res.totalCount
      } else {
        this.objectTableData = []
        this.objectTablePage.total = 0
      }
    },
    // 保存关联关系
    async saveObectTable() {
      if (!this.objectTableSelections.length) {
        this.$message.warning(this.$t('tickData'))
        return
      }
      const params = this.objectTableSelections.map((item) => {
        return {
          fileId: this.fileId,
          tagId: item.id,
          isManual: true,
          identifier: item.value,
        }
      })
      this.saveObjectTableLoading = true
      const res = await DocumentService.batchAddTagFileAssociation(params)
      this.saveObjectTableLoading = false
      if (res && res.code === 0) {
        this.$message.success(this.$t('saveSuccessFul'))
        this.objectTableVisible = false
        this.tagDataByFile()
      }
    },
    objectTableCurrentChange(val) {
      this.objectTablePage.pageNo = val
      this.getObjectTableData()
    },
    closeObjectTable() {
      this.objectTableVisible = false
    },
    // 批量关联
    batchAddTags() {
      if (!this.fileSelections.length) {
        this.$message.warning('请勾选左侧文件列表数据')
        return
      }
      this.uploadFileProps.visible = true
      this.uploadFileProps.active = 0
    },
    // 下载导入模板
    async exportTemplate() {
      const res = await documentManagementService.batchDownLoadAssociationTemplate()
      // 返回的是文件流
      if (res) {
        this.downLoadBlob({
          name: '批量关联导入模板.xlsx',
          data: res,
        })
      }
    },
    // 上传已填写的模板
    async importTemplate(fileList) {
      this.uploadFileProps.btnLoading = true
      const formData = new FormData()
      this.fileSelections.forEach((item) => {
        formData.append('documentFileIds', item.id)
      })
      let res
      const excelFiles = fileList.filter((file) => {
        const ext = file.name
          .split('.')
          .pop()
          .toLowerCase()
        return ext === 'xls' || ext === 'xlsx'
      })
      const xmlFiles = fileList.filter((file) => {
        const ext = file.name
          .split('.')
          .pop()
          .toLowerCase()
        return ext === 'xml'
      })
      // console.log("file", fileList)
      if (excelFiles.length === 1 && xmlFiles.length === 0) {
        const file = fileList[0]
        formData.append('file', file.raw)
        res = await documentManagementService.batchFileAssociationTag(formData)
      } else if (excelFiles.length === 0 && xmlFiles.length > 0) {
        this.mergeCount = 0
        this.batchKey = new Date().getTime().toString()
        this.md5List = []
        let checkUploadResult = true
        // 顺序上传文件
        for (let i = 0; i < fileList.length; i += 1) {
          try {
            const resData = await this.customUpload(fileList[i])
            if (!resData || resData.code !== 0) {
              checkUploadResult = false
            }
          } catch (error) {
            console.error('文件上传失败:', error)
            checkUploadResult = false
            this.uploadFileProps.btnLoading = false
            break
          }
        }
        if (checkUploadResult) {
          this.md5List.forEach((item) => {
            formData.append('md5s', item)
          })
          const resXML = await documentManagementService.batchDynamicTableData(formData)
          if (resXML && resXML.code === 0) {
            const progressKey = resXML.data
            // 调用子组件的方法传递进度key
            this.$refs.uploadXMLFile.setProgressKey(progressKey)
          }
        }
      }
      if (res) {
        this.downLoadBlob({
          name: '批量关联导入明细.xlsx',
          data: res,
        })
        this.handleSearchTag()
      }
      this.uploadFileProps.btnLoading = false
    },
    // 分片上传
    customUpload(file) {
      return new Promise((resolve, reject) => {
        const uploadId = ''
        // 初始化进度为0
        this.$set(file, 'percent', 0)
        this.calculateMD5(file.raw, this.sliceSize)
          .then(async (md5) => {
            try {
              // 每次上传前校验一下是否已经上传
              const resCheck = await documentManagementService.chunkDynamicUploadCheck(
                md5.toUpperCase()
              )
              if (resCheck === -1) {
                this.$message.warning('文件重复上传')
                if (!this.md5List.includes(md5.toUpperCase())) {
                  this.md5List.push(md5.toUpperCase())
                }
                resolve({
                  code: 0,
                  msg: `重复上传文件${md5.toUpperCase()}`,
                })
              } else {
                const blob = file.raw
                const partETags = []
                // eslint-disable-next-line no-unused-vars
                const { size: fileSize, name: fileName } = blob
                const totalSlice = Math.ceil(fileSize / this.sliceSize)
                this.md5List.push(md5.toUpperCase())

                /* eslint-disable no-await-in-loop */
                // 循环上传切片
                for (let i = 0; i < totalSlice; i += 1) {
                  await this.$nextTick()
                  const progress = Math.floor(((i + 1) / totalSlice) * 100)
                  this.$set(file, 'percent', progress)

                  const start = i * this.sliceSize
                  const chunkFile = blob.slice(start, Math.min(fileSize, start + this.sliceSize))

                  const formData = new FormData()
                  formData.append('file', chunkFile)

                  const resChunk = await documentManagementService.chunkDynamicUpload({
                    md5: md5.toUpperCase(),
                    chunk: i,
                    file: formData,
                  })
                  if (resChunk && resChunk.fileUrl) {
                    partETags.push({
                      partNumber: resChunk.chunk,
                      eTag: resChunk.fileUrl,
                    })

                    if (i + 1 === totalSlice) {
                      const mergeResult = await this.chunksMerge(md5, file)
                      resolve(mergeResult) // 合并完成后才进行下一个文件
                    }
                  } else {
                    throw new Error('切片上传失败')
                  }
                }
              }
              /* eslint-enable no-await-in-loop */
            } catch (error) {
              reject(error)
            }
          })
          .catch((error) => {
            this.$set(file, 'percent', 0)
            this.$message.error(error.message || '上传失败')
            this.uploadFileProps.btnLoading = false
            reject(error)
          })
      })
    },
    // 合并分片
    async chunksMerge(md5, file) {
      let res
      // 先增加合并次数
      this.mergeCount += 1
      // 传参
      const params = {
        fileName: file.name,
        md5: md5.toUpperCase(),
      }

      try {
        res = await documentManagementService.chunkDynamicUploadComplete(params)
        if (res && res.code === 0) {
          this.$set(file, 'percent', 100)
          if (this.mergeCount === this.fileList.length) {
            this.$message.success('上传成功')
            this.uploadFileProps.btnLoading = false
            // this.fileList = []
          }
        } else {
          this.$message.error(res.msg || '合并失败')
        }
      } catch (error) {
        this.$message.error(error.message || '合并失败')
        this.$set(file, 'percent', 0)
        this.uploadFileProps.btnLoading = false
      } finally {
        // 最后一个文件处理完成后，重置状态
        if (this.mergeCount === this.fileList.length) {
          this.uploadFileProps.btnLoading = false
          this.mergeCount = 0
        }
      }
      return res
    },
    // md5 的计算
    calculateMD5(file, chunkSize) {
      return new Promise((resolve, reject) => {
        const chunks = Math.ceil(file.size / chunkSize)
        const spark = new SparkMD5.ArrayBuffer()
        const fileReader = new FileReader()
        let currentChunk = 0

        fileReader.onload = (e) => {
          spark.append(e.target.result) // 更新 MD5 值
          currentChunk += 1
          if (currentChunk < chunks) {
            this.loadNextChunk(fileReader, currentChunk, chunkSize, file)
          } else {
            const md5 = spark.end() // 计算最终 MD5 值
            resolve(md5)
          }
        }
        // eslint-disable-next-line func-names
        fileReader.onerror = function(e) {
          reject(e)
        }
        this.loadNextChunk(fileReader, currentChunk, chunkSize, file)
      })
    },
    // md5 计算
    loadNextChunk(fileReader, currentChunk, chunkSize, file) {
      const start = currentChunk * chunkSize
      const end = Math.min(start + chunkSize, file.size)
      const chunk = file.slice(start, end)
      fileReader.readAsArrayBuffer(chunk)
    },
    // 重解关联
    async resolveTags() {
      if (!this.fileSelections.length) {
        this.$message.warning('请勾选左侧文件列表数据')
        return
      }
      const fileIdOriginIds = this.fileSelections.map((item) => {
        return item.fileIdOrigin
      })
      this.saveTagLoading = true
      const res = await documentManagementService.refreshTagFileAssociation({
        standardId: this.associatedDocumentsProps.standardId,
        documentId: this.associatedDocumentsProps.rowData.id,
        fileIdOriginIds,
      })
      this.saveTagLoading = false
      if (res && res.code === 0) {
        this.$message.success('操作成功')
        this.parseList = []
        _.forEach(res.data, (item) => {
          const fileType = item.fileNameOrigin
            .split('.')
            .at(-1)
            .toLowerCase()
          if (this.modelType.includes(fileType)) {
            const parseObj = {
              name: item.fileNameOrigin,
              percent: 0,
              msg: item.tagCount ? '解析中' : '等待中',
              fileId: item.fileIdOrigin,
            }
            this.parseList.push(parseObj)
            if (item.tagCount) {
              this.getParseProgress({
                progressKey: item.progressKey,
                file: parseObj,
              })
            } else {
              this.parseQueue.push({
                fileId: item.fileIdOrigin,
              })
            }
          }
        })
        if (this.parseQueue.length && this.config.isVulkan) {
          this.saveTagLoading = true
          this.parseModelTag()
        }
        this.handleSearchTag()
      }
    },
    async parseModelTag() {
      if (this.parseQueue.length === 0) {
        this.showModelView = false
        this.modelParams = []
        this.modelProps = {}
        this.modelName = ''
        this.saveTagLoading = false
        return
      }
      const data = this.parseQueue.shift()
      const fileRes = await DocumentService.getDocumentFileType({
        standardId: this.standardId,
        fileId: data.fileId,
      })
      const file = _.find(this.parseList, { fileId: data.fileId })
      file.msg = '模型对象获取中（请不要关闭）'
      this.$set(file, 'seconds', 0)
      const timer = setInterval(() => {
        this.$set(file, 'seconds', file.seconds + 1)
      }, 1000)
      this.$set(file, 'timer', timer)
      this.currentParseFileId = data.fileId
      if (fileRes?.code === 0) {
        const name = fileRes.data.fileNameOrigin || fileRes.data.fileName
        const modelType = name
          .split('.')
          .at(-1)
          .toLowerCase()
        this.modelParams = [
          {
            ..._.pick(fileRes.data, ['fileId', 'documentId']),
            name,
            type: modelType,
            md5: fileRes.data.fileOriginMd5,
          },
        ]
        this.modelProps = {
          defaultModelId: fileRes.data.documentId,
        }
        this.modelName = fileRes.data.documentId
        this.showModelView = true
      }
    },
    async loadedAllModel() {
      try {
        const root = await this.mainPlayer.Native.Node.getRoot()
        const children = await this.mainPlayer.Native.Node.collectChildrenWithCode(root)
        const childrenInfo = await this.mainPlayer.Native.Node.getProperty(children, ['code'])
        const tags = []
        _.forEach(childrenInfo, (item) => {
          if (item.code) {
            tags.push(item.code)
          }
        })
        const res = await ModelServer.analysisModelTag({
          standardId: this.standardId,
          documentId: this.modelName,
          tags,
        })
        const file = _.find(this.parseList, { fileId: this.currentParseFileId })
        clearInterval(file.timer)
        this.$set(file, 'timer', null)
        if (res && res.code === 0) {
          file.msg = '解析中'
          this.getParseProgress({
            progressKey: res.details.progressKey,
            file,
          })
        } else {
          file.msg = '解析失败'
        }
        this.parseModelTag()
      } catch (error) {
        const file = _.find(this.parseList, { fileId: this.currentParseFileId })
        this.$set(file, 'msg', error)
        this.loadError()
      }
    },
    async getParseProgress(data) {
      const res = await documentManagementService.getDocumentBatchRelationProgress(data.progressKey)
      if (res) {
        data.file.percent = res.currentProgress
        if (res.hasError) {
          data.file.msg = res.status
        } else if (res.isCompleted) {
          data.file.msg = '解析完成'
        } else if (res.currentProgress !== 100) {
          setTimeout(() => {
            this.getParseProgress(data)
          }, 1500)
        }
      }
    },
    loadError(error) {
      const file = _.find(this.parseList, { fileId: this.currentParseFileId })
      this.$set(file, 'msg', error)
      this.parseQueue = []
      this.parseList = []
      this.showModelView = false
      this.modelParams = []
      this.modelProps = {}
      this.modelName = ''
      this.saveTagLoading = false
      this.parseList.forEach((item) => {
        if (item.timer) {
          clearInterval(item.timer)
          item.timer = null
        }
      })
    },
  },
}
</script>

<style ref="stylesheet/scss" type="text/scss" lang="scss" scoped>

.uploadDoc /deep/.el-upload {
  width: 100% !important;
}
.uploadDoc /deep/.el-upload-dragger {
  width: 100% !important;
  height: 230px !important;
}

::v-deep .progress-loading .el-progress-bar__outer {
  background: repeating-linear-gradient(-45deg, #fff 0.5px 10px, #ebeef5 0px 40px) 0/200% 100%;
  animation: i3 10s linear infinite;
}
@keyframes i3 {
  100% {
    background-position: right;
  }
}

</style>
